import { createContext, useContext } from 'react'

export const RollbackContext = createContext<any>(undefined)

export const useRollback = () => useContext(RollbackContext)
